export default __webpack_public_path__ + "static/media/iusd_5_11zon.dc69d254.png";